//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { call } from 'vuex-pathify'
import RolFormDialog from "./RolFormDialog"
import Rol from '@/api/promotores/roles.api'
import ColumnsSelect from '@/components/ColumnsSelect'
import SearchInput from '@/components/SearchInput'

export default {
  components: { ColumnsSelect, SearchInput },
  data() {
    return {
      loading: false,
      roles: [],
      filter: null,
      visible_columns: ['id', 'nombre', 'slug', 'usuarios', 'dominios', 'created_at'],
      columns: [
        { name: "id", field: "id", label: "Id", sortable: true, style: "width: 10px" },
        {
          name: "nombre",
          field: "nombre",
          label: "Nombre",
          style: "width: 60%",
          align: "left",
          classes: "bg-grey-2 ellipsis",
          headerClasses: "bg-primary text-white",
          sortable: true,
        },
        { name: "slug", field: "slug", label: "Clave", sortable: true, align: 'left' },
        { name: 'usuarios', label: 'Promotores', field: 'usuarios_count', sortable: true },
        { name: 'audiencia', label: 'Audiencia/Lista', field: 'mailchimp_list_id', sortable: true },
        { name: 'dominios', label: 'Dominios', field: 'email_dominios', sortable: true },
        { name: "comision_base", field: "comision_base", label: "Comisión Base", sortable: true },
        {
          name: "created_at",
          field: "created_at",
          label: "Creación",
          format: this.momentFromNow,
          sortable: true,
        },
      ],
    }
  },

  mounted() {
    this.loadRoles()
  },

  methods: {
    search: call("app/search"),

    async loadRoles() {
      try {
        this.loading = true
        this.roles = await Rol.all()
      } finally {
        this.loading = false
      }
    },
    openRolCreate() {
      this.$q.dialog({
        component: RolFormDialog,
      })
        .onOk((rol) => {
          this.loadRoles()
        })
    },
    openRolEdit(rol) {
      this.$q.dialog({
        component: RolFormDialog,
        rol
      })
        .onOk((rol) => {
          this.loadRoles()
        })
    },
  },
}
